import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import { autoTranslate } from "@web-monorepo/vite-auto-translate-plugin/runtime";
import React from "react";

interface SavedToolNewButtonProps {
  onClick: VoidFunction;
  children: React.ReactNode;
  backgroundColor: string;
  color: string;
}

const SavedToolNewButton = ({ onClick, children, backgroundColor, color }: SavedToolNewButtonProps) => {
  return (
    <li>
      <button
        data-name="saved_tool_new_button:create_new_item"
        aria-label={autoTranslate("Create new item")}
        onClick={onClick}
        sx={{ ...buttonStyle, backgroundColor: RAW_cssValue(backgroundColor), color }}
      >
        <span sx={buttonTextStyle}>{children}</span>
      </button>
    </li>
  );
};

export default SavedToolNewButton;

const buttonStyle: ThemeUIStyleObject = {
  display: "flex",
  alignItems: "center",
  minHeight: "80px",
  width: "100%",
  margin: RAW_cssValue("10px 0"),
  padding: "dt_l",
  border: "dt_card",
  borderRadius: "dt_radius_s",
  backgroundColor: "dt_background_primary",
  fontSize: "18px",
  textAlign: "left",
  verticalAlign: "middle",
  boxShadow: "dt_shadow_shadezies_small",
  cursor: "pointer",
  userSelect: "none",
};

const buttonTextStyle: ThemeUIStyleObject = {
  flex: "1",
  textAlign: "center",
  wordWrap: "break-word",
  minWidth: "50%",
  margin: RAW_cssValue(16),
  lineHeight: 1.2,
};
